export default class IService {
    /**
     * Constructor
     * @param provider {ServiceProvider}
     * @param config {Object}
     */
    constructor(provider, config) {
        this.$services = provider;
        this.config = config;
    }
}